import actions from "./actions";

const { FETCH_PRE_ROUTINES, FETCH_PRE_ROUTINE, RESET_PRE_ROUTINE } = actions;

const initState = {
    preRoutines: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    preRoutine: { _id: null }
};

const PreRoutineReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_PRE_ROUTINES:
            return {
                ...state,
                preRoutines: data
            };
        case RESET_PRE_ROUTINE:
            return {
                ...state,
                preRoutine: initState.preRoutine,
            };
        case FETCH_PRE_ROUTINE:
            return {
                ...state,
                preRoutine: data,
            };
        default:
            return state;
    }
};

export default PreRoutineReducer;
